import React from 'react';
import Layout from '../components/layout/Layout';

const PrivacyPage = () => {
  return (
    <Layout>
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-gray-300">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
          <p className="text-gray-600 mb-4">We collect information you provide directly to us, including:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Personal information (name, email, phone number)</li>
            <li>Educational information (school, grade level)</li>
            <li>Payment information (processed securely through third-party providers)</li>
            <li>Communication preferences</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
          <p className="text-gray-600 mb-4">We use collected information to:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Provide and improve our educational services</li>
            <li>Process orders and deliver products</li>
            <li>Send important updates and communications</li>
            <li>Issue certifications and track progress</li>
            <li>Respond to inquiries and support requests</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Information Sharing</h2>
          <p className="text-gray-600 mb-6">
            We do not sell or rent your personal information. We may share information with:
            trusted service providers who assist in our operations, when required by law, or to protect 
            our rights and safety.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Data Security</h2>
          <p className="text-gray-600 mb-6">
            We implement appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction. However, no internet transmission 
            is completely secure.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Children&apos;s Privacy</h2>
          <p className="text-gray-600 mb-6">
            Our services are designed for educational purposes. For users under 18, we require parental 
            or guardian consent. Parents may review, modify, or delete their child&apos;s information by contacting us.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Your Rights</h2>
          <p className="text-gray-600 mb-4">You have the right to:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
            <li>Data portability</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Cookies</h2>
          <p className="text-gray-600 mb-6">
            We use cookies to enhance your experience. See our Cookie Policy for detailed information 
            about our cookie practices.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Contact Us</h2>
          <p className="text-gray-600 mb-6">
            For privacy-related inquiries:<br />
            Email: info@steamie.net<br />
            Phone: +91 79966 97777<br />
            Address: #101,102 ARG Shopping Complex, Jaipur Road, Ajmer, Rajasthan 305001
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPage;
